import { render, staticRenderFns } from "./edit-result.vue?vue&type=template&id=7824f08c&scoped=true&"
import script from "./edit-result.vue?vue&type=script&lang=js&"
export * from "./edit-result.vue?vue&type=script&lang=js&"
import style0 from "./edit-result.vue?vue&type=style&index=0&id=7824f08c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7824f08c",
  null
  
)

export default component.exports